import { useContext } from 'react'
import { GameBoardContext } from '../components/GameBoard/GameBoardProvider'

export const useGameBoardActions = () => {
  return useContext(GameBoardContext)
}
